import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import CreateInvoiceForm from "./Form";

const FETCH_SO_DETAIL = gql`
  query FETCH_SO_DETAIL($id: Int!) {
    odooSo(instance: "AB", ids: [$id], useType: "ANITA")
  }
`;

const OdooOrderDetail = ({ id }) => {
  const { loading, error, data } = useQuery(FETCH_SO_DETAIL, {
    variables: { id },
    skip: !id,
  });
  if (loading) return <Spinner text="Loading Odoo Order.." />;
  if (error) return <Errors error={error} />;

  const res = JSON.parse(data.odooSo)[0];

  console.log("res", res);

  return <CreateInvoiceForm so={res} />;
};

export default OdooOrderDetail;
